module.exports = __webpack_public_path__ + "static/background-7339d422366fda2b753d4f4eb2d8ca5d.svg";